import axios from 'axios';

import { omit } from 'lodash';
import { notification } from 'antd';

import Settings from '../setting';
import getCookie from './getCookie';
import { ssoUrl } from './ssoPath';
import * as responseCode from './responseCode';

const url = Settings.API;

const defaultPath = {
  dashbord: 'eoms',
  'order-management': 'eoms',
  'shop-management': 'eoms',
  'event-management': 'eoms',
  'work-sheet-anagement': 'eoms',
  'yu-balance': 'ysettlement',
  'sms-management': 'recall',
};

const getPath = urlPath => {
  return defaultPath[urlPath.split('/')[1]] || 'eoms';
  // return defaultPath[urlPath.split('/')[1]] || 'eoms';
};

const http = axios.create({
  timeout: 30 * 1000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
});

http.interceptors.request.use(config => {
  if (config.headers.urlPrefix) {
    return {
      ...config,
      baseURL: `${url}/${config.headers.urlPrefix}/`,
      headers: {
        ...omit(config.headers, ['urlPrefix']),
        Authorization: config.url === 'logout' ? getCookie('refreshToken') : getCookie('token'),
      },
    };
  }

  return {
    ...config,
    baseURL: `${url}/${getPath(window.location.pathname)}/`,
    headers: {
      ...config.headers,
      Authorization: config.url === 'logout' ? getCookie('refreshToken') : getCookie('token'),
    },
  };
});

http.interceptors.response.use(res => {
  if (res.data.code === responseCode.INVALID_TOKEN) {
    document.cookie = 'token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    // window.location.href = ssoUrl;
  }

  if (res.data.code !== responseCode.SUCCESS && !(res.data instanceof Blob)) {
    notification.error({
      message: '错误',
      description: res.data.message || res.data.msg,
    });
  }

  return res.data;
});

export default http;
